var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('div',{staticClass:"h-100"},[_c('div',{staticClass:"h-100"},[(_vm.embedInfo.token)?_c('PBIReport',{attrs:{"report-id":_vm.reportId}}):_vm._e()],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }